import * as home from './home.js';

export const pageInitializers = [
    home,
];
